// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  origin: 'https://mpapitest-5.radiantdelivers.com/api/v1/gd/',
  mock: true,
  version: require( '../../../../package.json' ).version,
  gtagId: '',
  lambdaApi: 'https://i21kwaygt6.execute-api.us-east-1.amazonaws.com/Stage/',
  maintenanceUrl: 'https://rgl-static-cdn.s3.amazonaws.com/maintenance_dev.json'
};
